// extracted by mini-css-extract-plugin
export default {"container":"NavigationBar_container__WBZLR","button":"NavigationBar_button__ThNr8","forced_dark":"NavigationBar_forced_dark__F1Kt5"};